<template>
  <div id="ano">
    <div class="top-header1">
      <img
        src="/sandboxfront/mapatributario/logo_mini.svg"
        alt=""
        style="margin:30px 0px;"
      />
      <div class="title">
        <div style="display: flex;justify-content: left; gap: 8px;">
          <img
            src="https://www.lefisc.com.br/consultaGtin/images/consult.svg"
            alt=""
          />
          <h2 style="color:#fff;font-weight: 400;margin:0px;">
            Informe o produto que deseja consultar
          </h2>
        </div>
      </div>
    </div>
    <div class="container-seletor">
      <div class="dividir">
        <label
          for=""
          style="margin-top:40px;color: rgb(74, 21, 75);font-weight: bold; font-size: 18px;
    margin-bottom: 8px;"
          >Digite a NCM do produto:</label
        >
        <input
          type="text"
          placeholder="Ex. 0000.00.00"
          v-model="ncm"
          @keypress="mascara()"
          maxlength="10"
          style="background: #EDE4ED;border: 1px solid #4A154B;border-radius: 5px;padding: 8px;
    width: 310px;"
        />

        <label
          for="pet-select"
          style="margin-top:40px;color: #4A154B;font-weight: bold;font-size: 18px;
    margin-bottom: 8px;"
          >Selecione o Estado da operação:</label
        >
        <select
          name="pets"
          id="pet-select"
          style="background: #EDE4ED;border: 1px solid #4A154B;border-radius: 5px;padding: 8px;
    width: 310px;"
        >
          <option value="0">Selecione a UF:</option>
          <option
            :value="estado.uf"
            v-for="estado in estados"
            :key="estado.id"
            >{{ estado.estado }}</option
          >
        </select>
        <button class="btn-escolher" @click="continuar">
          <img
            src="/sandboxfront/mapatributario/pesquisa_btn.svg"
            alt=""
            style="    width: 18px;"
          />
          <span>Consultar</span>
          <div v-show="spiner" class="er"></div>
        </button>
        <p style="margin-top:30px;color:red;">{{ msg }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import index from "../services/index";
export default {
  data() {
    return {
      msg: "",
      estados: [],
      ncm: "",
      estado: "",
      spiner: false,
    };
  },
  methods: {
    mascara() {
      setTimeout(() => {
        this.ncm = this.ncm.replace(/\D/g, "");
        this.ncm = this.ncm.replace(/(\d{4})/, "$1.");
        this.ncm = this.ncm.replace(/(\d{4}).(\d{2})/g, "$1.$2.");
      }, 0.1);
    },
    async continuar() {
      var value = document.getElementById("pet-select").value;
      if (this.ncm.length >= 10) {
        if (value != 0) {
          this.spiner = true;
          let res = await index.VerificaNcm(this.ncm);
          console.log(res);
          if (res) {
            this.$router.push({
              name: "estado",
              params: {
                ncm: this.ncm,
                uf: document.getElementById("pet-select").value,
              },
            });
          } else {
            this.spiner = false;
            this.msg = "NCM não encontrada";
          }
        } else {
          this.msg = "Selecione o Estado da sua operação";
        }
      } else {
        this.msg = "Informe a NCM que deseja  analisar";
      }
    },
    irPag() {},
  },
  async mounted() {
    window.scrollTo(0, 0);
    await axios
      .get(
        "https://www.lefisc.com.br/api/covid19/estados/7c555a0cc655264a9455770359ffb7d9",
      )
      .then((e) => {
        this.estados = e.data;
      });
  },
};
</script>
<style>
.er {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 6px solid lightgray;
  border-top-color: #ffffff;
  animation: spinner 0.7s linear infinite;
  display: block;
  position: relative;
  margin-left: 15px;
}
@keyframes spinner {
  to {
    transform: rotate(360deg);
  }
}
.btn-escolher {
  background: #4a154b;
  border-radius: 5px;
  display: flex;
  min-width: 120px;
  padding: 8px;
  color: #fff;
  margin-top: 30px;
  font-size: 16px;
  font-weight: bold;
  justify-content: space-around;
  align-items: center;
}
.container-seletor {
  margin: 0 auto;
  max-width: 1200px;
  background: #fff;
}
.container-seletor .dividir {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.title {
  max-width: 1200px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: baseline;
  border-bottom: 1px solid #ffffff;
  width: 100%;
  padding-bottom: 5px;
}
.top-header1 {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #4a154b;
  padding: 0 32px 24px;
}
#ano {
  min-height: 95vh;
  background: #fff;
}
</style>
